unable to read source [project]/node_modules/stripe/src/resources/TestHelpers/Treasury/index.ts